import AuthService from "@/services/auth.service";
import router from "@/router";

const state = {
    user: localStorage.getItem("EFFuser") && JSON.parse(localStorage.getItem("EFFuser")),
    //oulist:[], 20220601
    IsProdEnvironment:false
};

const getters = {
    isAuthenticated: (state) => !!state.user
};

const mutations = {
    auth_success(state, user) {
        state.user = user
    },

    auth_clear(state) {
        state.user = null
    },

    /*
    onoulist_fetched(state, list){
        state.oulist = list
    },
    */

    IsProdEnvironment_fetched(state, res){
        state.IsProdEnvironment = res
    }

};

const actions = {

    /* 20220601
    async EnumarateADOUList({commit}) {
        var resouList = await AuthService.api_enumADOUList();

        commit("onoulist_fetched", resouList);
    },
    */


    async getIsProdEnvironment({commit}) {
        var isProdEnv = await AuthService.getIsProdEnvironment_service();

        commit("IsProdEnvironment_fetched", isProdEnv);
    },

    async login({commit}, {email, password, selectedOU}) {
        var user = await AuthService.login(email, password,selectedOU);

        commit("auth_success", user);
        router.push(router.history.current.query.redirect || "/");
    },

    async refreshToken({commit}) {
        var user = await AuthService.refreshToken();

        commit("auth_success", user);
    },

    logout({commit}) {
        AuthService.logout();
        commit("auth_clear");
        router.push("/login")
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
